import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=04dafcfc&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=04dafcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dafcfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dafcfc')) {
      api.createRecord('04dafcfc', component.options)
    } else {
      api.reload('04dafcfc', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=04dafcfc&scoped=true&", function () {
      api.rerender('04dafcfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/shared/sidebar.vue"
export default component.exports